import React from 'react';
import { AlertTriangle } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full bg-[#f8f9fa] pt-16 pb-12 px-4 border-b border-gray-200" data-id="element-37">
      <div className="max-w-4xl mx-auto space-y-8" data-id="element-38">
        <div className="text-center space-y-8" data-id="element-39">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-navy-900 leading-tight" data-id="element-40">
            "Por Qué el 94% de las Personas que Intentan Recuperar a su Pareja
            Fracasan — Y el Factor Oculto que Determina Quién Realmente Lo
            Logra"
          </h1>

          <div className="bg-gray-800 text-white py-4 px-6 rounded-sm shadow-sm" data-id="element-41">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm md:text-base font-medium text-center divide-y md:divide-y-0 md:divide-x divide-gray-600" data-id="element-42">
              <div className="py-2 md:py-0" data-id="element-43">
                Período de investigación: 2022 — Presente
              </div>
              <div className="py-2 md:py-0" data-id="element-44">Casos documentados: 15,000+</div>
              <div className="py-2 md:py-0" data-id="element-45">Cobertura: Estados Unidos</div>
            </div>
          </div>
        </div>

        <div className="mt-12 bg-red-50 border-l-8 border-red-700 p-6 md:p-8 shadow-sm" data-id="element-46">
          <div className="flex items-start gap-4" data-id="element-47">
            <AlertTriangle className="w-8 h-8 text-red-700 flex-shrink-0 mt-1" data-id="element-48" />
            <div data-id="element-49">
              <h3 className="text-xl font-bold text-red-900 mb-2 uppercase tracking-wide" data-id="element-50">
                ⚠️ SI ESTÁS BUSCANDO AYUDA ESPIRITUAL PARA RECUPERAR A TU PAREJA
                — LEE ESTO PRIMERO.
              </h3>
              <p className="text-lg text-red-800 leading-relaxed font-medium" data-id="element-51">
                Lo que estás a punto de leer podría salvarte de perder miles de
                dólares y meses de sufrimiento adicional.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}